import React from 'react';
import {Icon, Row} from 'antd';
import Template from "./../../interfaz/Template.js";
import {registrarTerminado} from   "../../../redux/user/user-actions";
import {connect} from 'react-redux'
import { createStructuredSelector } from 'reselect';
import { Link } from "react-router-dom";
import exitoModificaJDE from '../../../img/info16_datos_actualizados_JDE.png';
import { selectEstatusExito } from '../../../redux/user/user-selectors.js';

class ExitoActualiza extends React.Component {

    componentWillUnmount() {}

    render() {
        return(
            <Template contenido={
                <div className="exito_container">
                    <div style={{'margin':'95px auto'}}>
                        <center>
                            <img src={exitoModificaJDE} alt="ExitoModifica" width="100%" height="100%"/>
                            <br/><br/>
                            <br/><br/>
                                <Link to={'/bandeja'} className="btn btn-success mr-2" style={{fontSize: '1.5em'}}>
                                    Regresar a bandeja
                                </Link>
                        </center>
                        <br/><br/>
                    </div>
                </div>
            }
            guia={false}
            />
        );
    }
};

const mapStateToProps = createStructuredSelector({
    ventanaExito: selectEstatusExito
});

const mapDispatchToProps = dispatch => ({
	registrarTerminado: exito => dispatch(registrarTerminado(exito))
});

export default connect(mapStateToProps, mapDispatchToProps)(ExitoActualiza);
